import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projectResource, nextProjectResource }) => {
    return present(
      repository
        .editProjectResource(projectResource, nextProjectResource)
        .catch(() => Promise.reject({ projectResource, nextProjectResource })),
    );
  };
}

export type { Interactor };

export { createInteractor };
